import React from "react"
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core"

import SubscriptionsTable from "./SubscriptionsTable"
import { Scope } from "@ua/web-sdk/lib/remote-data/preference-center"
import { SubscriptionList } from "@root/store/types"

export const SCOPES: Scope[] = ["app", "email", "sms", "web"]
export interface Props {
  type: "contact" | "channel"
  lists: SubscriptionList[]
  onAddList(list: string, scope?: Scope): void
  onRemoveList(list: string, scope?: Scope): void
}

const useStyles = makeStyles({
  button: {
    alignSelf: "center",
  },
})

const Subscriptions: React.FC<Props> = ({
  type,
  lists,
  onAddList,
  onRemoveList,
}) => {
  const [list, setList] = React.useState("")
  const [scope, setScope] = React.useState<Scope>("app")
  const classes = useStyles()

  return (
    <>
      <SubscriptionsTable
        type={type}
        lists={lists}
        onRemoveList={onRemoveList}
        onAddList={onAddList}
      />

      <Typography variant="h6">Add New</Typography>
      <Box
        data-qa-selector="subscriptions-form"
        component="form"
        onSubmit={(ev) => {
          ev.preventDefault()
          onAddList(list, scope)
          setList("")
          setScope("app")
        }}
      >
        <Grid container spacing={2}>
          {type === "channel" && (
            <Grid item sm={10} xs={12}>
              <TextField
                required
                fullWidth
                data-qa-selector="channel-list-id-input"
                id="channel-list-id-id"
                label="List ID"
                value={list}
                onChange={(ev) => setList(ev.target.value)}
              />
            </Grid>
          )}
          {type === "contact" && (
            <>
              <Grid item sm={6} xs={12}>
                <TextField
                  required
                  fullWidth
                  data-qa-selector="contact-list-id-input"
                  id="contact-list-id-id"
                  label="List ID"
                  value={list}
                  onChange={(ev) => setList(ev.target.value)}
                />
              </Grid>
              <Grid item sm={4} xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="contact-subscription-scopes-label">
                    Scope
                  </InputLabel>
                  <Select
                    required
                    data-qa-selector="contact-scope-input"
                    id="contact-scope-id"
                    labelId="contact-subscription-scopes-label"
                    value={scope}
                    onChange={(ev) => setScope(ev.target.value as Scope)}
                  >
                    {SCOPES.map((s: Scope, idx) => (
                      <MenuItem key={`${scope}.${idx}`} value={s}>
                        {s}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </>
          )}
          <Grid item sm={2} xs={12} className={classes.button}>
            <Button
              fullWidth
              data-qa-selector="submit"
              type="submit"
              variant="contained"
              disabled={!list}
            >
              Subscribe
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default Subscriptions
